/* THE PAUSE — Header scroll effect
   À coller dans assets/pause-header.js
   puis inclure dans theme.liquid */

document.addEventListener('DOMContentLoaded', function () {
  const headerWrapper = document.querySelector('.header-wrapper');
  if (!headerWrapper) return;

  // On récupère la hauteur de la hero pour savoir quand shrink
  function getHeroHeight() {
    const hero = document.querySelector('.pause-hero, .hero, [data-section-type="hero"]');
    if (hero) return hero.offsetHeight * 0.6; // shrink à 60% de la hero
    return window.innerHeight * 0.6; // fallback = 60vh
  }

  function updateHeader() {
    const threshold = getHeroHeight();
    if (window.scrollY > threshold) {
      headerWrapper.classList.add('scrolled');
    } else {
      headerWrapper.classList.remove('scrolled');
    }
  }

  window.addEventListener('scroll', updateHeader, { passive: true });
  window.addEventListener('resize', updateHeader, { passive: true });
  updateHeader(); // état initial
});